import React from 'react';
import {
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBCollapse,
  MDBRow,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBCloseIcon,
  MDBDataTable,
} from 'mdbreact';

export const ModalRelatorioLeitura = ({
  modalLeitura,
  setModalLeitura,
  pdf,
}) => {
  console.log('PDF:', pdf);
  // Define the columns for the datatable
  const columns = [
    {
      label: 'Nome do Arquivo',
      field: 'nome',
      sort: 'asc',
    },
    {
      label: 'Usuário',
      field: 'usuario_nome',
      sort: 'asc',
    },
    {
      label: 'Data de Leitura',
      field: 'createdAt',
      sort: 'asc',
    },
  ];

  
  const rows = pdf?.relato_pdf_leituras?.map((leitura) => ({
    id: pdf.id,
    denuncia_id: pdf.denuncia_id,
    nome: pdf.nome,
    usuario_nome: `${leitura?.usuario?.nome} ${leitura?.usuario?.sobrenome}`,
    createdAt: new Date(leitura?.created_at).toLocaleString(), // Format date for readability
  }));

  // Create the data object for MDBDataTable
  const data = {
    columns,
    rows,
  };

  return (
    <MDBModal
      isOpen={modalLeitura}
      toggle={() => setModalLeitura(!modalLeitura)}
      size="lg"
      centered
    >
      <MDBModalHeader toggle={() => setModalLeitura(!modalLeitura)}>
        Relatório de Leitura
      </MDBModalHeader>
      <MDBModalBody>
        <MDBDataTable
          bordered
          small
          data={data}
        />
      </MDBModalBody>
    </MDBModal>
  );
};